/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './nutrition-plan.reducer';

export const NutritionPlanDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const nutritionPlanEntity = useAppSelector(state => state.nutritionPlan.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="nutritionPlanDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.nutritionPlan.detail.title">NutritionPlan</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.nutritionPlan.id">Id</Translate>
            </span>
          </dt>
          <dd>{nutritionPlanEntity.id}</dd>
          <dt>
            <span id="planName">
              <Translate contentKey="tinyMedicRestApp.nutritionPlan.planName">Plan Name</Translate>
            </span>
          </dt>
          <dd>{nutritionPlanEntity.planName}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.nutritionPlan.description">Description</Translate>
            </span>
          </dt>
          <dd>{nutritionPlanEntity.description}</dd>
          <dt>
            <span id="tmType">
              <Translate contentKey="tinyMedicRestApp.nutritionPlan.tmType">Tm Type</Translate>
            </span>
          </dt>
          <dd>{nutritionPlanEntity.tmType}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.nutritionPlan.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{nutritionPlanEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.nutritionPlan.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{nutritionPlanEntity.timestampentry}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.nutritionPlan.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{nutritionPlanEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.nutritionPlan.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{nutritionPlanEntity.cursor}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.nutritionPlan.active">Active</Translate>
            </span>
          </dt>
          <dd>{nutritionPlanEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="tmRank">
              <Translate contentKey="tinyMedicRestApp.nutritionPlan.tmRank">Tm Rank</Translate>
            </span>
          </dt>
          <dd>{nutritionPlanEntity.tmRank}</dd>
        </dl>
        <Button tag={Link} to="/nutrition-plan" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/nutrition-plan/${nutritionPlanEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default NutritionPlanDetail;
